module.exports = __webpack_public_path__ + "static/img/m_del_num.92ff7630.svg";